import styled from 'styled-components';
import { StyledLinkButton } from '../../../common/components/Button/StyledButtons';
import { HeImgix } from '../../../common/components/images/HeImgix';
import { Col } from '../../../common/components/layout/FlexLayout';
import { PageSection } from '../../../common/components/layout/PageSection/PageSection';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint } from '../../../common/styles/constants';

export const PrescriptionSectionPageSection = styled(PageSection)`
  background-color: ${ThemeColours.primary300};
`;

export const PrescriptionSectionCol = styled(Col)`
  width: 52%;

  ${StyledLinkButton} {
    margin-top: 10px;
  }

  ${Breakpoint.MEDIUM} {
    align-items: flex-start;
    width: 60%;

    ${StyledLinkButton} {
      margin-top: 10px;
      width: auto;
    }
  }
`;

export const PrescriptionSectionGraphic = styled(HeImgix)`
  align-self: flex-end;
  height: auto;
  margin-left: -5%;
  position: relative;
  width: 100%;

  ${Breakpoint.MEDIUM} {
    width: 50%;
  }
`;
